<template>
  <div class="index-box">
    <div class="cover" id="cover" v-show="loadingShow">
      <img src="../assets/phone.png" class="tip" />
      <div class="tip-text">为了更好的体验，请将手机横屏观看</div>
    </div>
    <div
      class="index-bg"
      id="contanier"
      @scroll="handleScroll"
      v-show="!loadingShow"
    >
      <div
        v-for="(item, index) in 12"
        :key="index"
        class="item"
        :class="'item' + item"
      ></div>
      <img
        src="../assets/text1.png"
        class="text text1 animated hidden"
        id="text1"
      />

      <div class="bird3-box">
        <img src="../assets/bird3.png" class="text bird3" />
      </div>

      <div class="bird4-box">
        <img src="../assets/bird4.png" class="text bird4" />
      </div>

      <img src="../assets/b1.png" class="text b1" />
      <img src="../assets/b2.png" class="text b2" />
      <img src="../assets/p1.png" class="text p1 animated hidden" id="p1" />
      <img src="../assets/p2.png" class="text p2 animated hidden" id="p2" />
      <img src="../assets/bird1.gif" class="text bird1" />
      <img src="../assets/bird2.gif" class="text bird2" />
      <div class="bird5-box">
        <img src="../assets/bird11.png" class="text bird5" />
      </div>

      <div class="bird8-box">
        <img src="../assets/bird8.png" class="text bird8" />
      </div>
      <div class="bird9-box">
        <img src="../assets/bird9.png" class="text bird9" />
      </div>
      <div class="bird10-box">
        <img src="../assets/bird10.png" class="text bird10" />
      </div>
      <div class="bird12-box">
        <img src="../assets/bird12.png" class="text bird12" />
      </div>

      <div class="text plane">
        <img src="../assets/jiang1.png" class="jiang1" />
        <img src="../assets/jiang2.png" class="jiang2" />
        <img src="../assets/jiang3.png" class="jiang3" />
        <img src="../assets/jiang4.png" class="jiang4" />
      </div>
      <img
        src="../assets/ping_btn.png"
        class="ping ping1 animated hidden"
        id="ping1"
        @click="toPing(0)"
      />
      <img
        src="../assets/ping_btn.png"
        class="ping ping2 animated hidden"
        id="ping2"
        @click="toPing(1)"
      />
      <img
        src="../assets/ping_btn.png"
        class="ping ping3 animated hidden"
        id="ping3"
        @click="toPing(2)"
      />
      <img
        src="../assets/ping_btn.png"
        class="ping ping4 animated hidden"
        id="ping4"
        @click="toPing(3)"
      />
      <img
        src="../assets/ping_btn.png"
        class="ping ping5 animated hidden"
        id="ping5"
        @click="toPing(4)"
      />

      <div class="b3-box">
        <img src="../assets/b3.png" class="text b3 animated hidden" id="b3" />
      </div>

      <img src="../assets/jingmen.png" class="text jingmen" />

      <div class="car-box">
        <img src="../assets/car1.png" class="text car1" />
      </div>
    </div>
    <div v-show="showCover">
      <!-- <div class="left-box black-box" id="leftBox"></div>
      <div class="right-box black-box" id="rightBox"></div> -->
      <div class="cover-box" id="coverBox"></div>
      <img
        src="../assets/btn.png"
        class="light-btn"
        @click="getLight"
        v-if="showBtn"
      />
    </div>
    <div class="deng-box" v-if="gifShow">
      <img src="../assets/right.png" class="right right1" />
      <img src="../assets/right.png" class="right right3" />
      <img src="../assets/right.png" class="right right6" />
      <img src="../assets/right.png" class="right right7" />
      <img src="../assets/right.png" class="right right9" />
      <img src="../assets/right.png" class="right right10" />
      <img src="../assets/right.png" class="right right12" />
      <img src="../assets/right.png" class="right right13" />
      <img src="../assets/right.png" class="right right15" />
      <img src="../assets/right.png" class="right right16" />
      <img src="../assets/right.png" class="right right18" />
    </div>
    <div class="tip-box" v-if="showTip" @touchstart="showTip = false">
      <img src="../assets/hand.png" class="head" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contanier: null,
      url: "http://cdn.joyoung-ad.com/00images/200707jinrongjie/",
      fontSize: 0,
      timer: null,
      // loadingShow: true,
      // gifShow: false,
      // showCover: false,
      // showBtn: false,
      // showTip: false,

      loadingShow: true,
      gifShow: false,
      showCover: true,
      showBtn: true,
      showTip: false,
      scrollTop: 0,
    };
  },
  created() {
    this.loadImg();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    loadImg() {
      let that = this;
      let imgNum = 0;
      let top = this.$route.query.top;
      if (!top) {
        let imgArry = [
          require("../assets/bg_1.jpg"),
          require("../assets/bg_2.jpg"),
          require("../assets/bg_3.jpg"),
          require("../assets/bg_4.jpg"),
          require("../assets/bg_5.jpg"),
          require("../assets/bg_6.jpg"),
          require("../assets/bg_7.jpg"),
          require("../assets/bg_8.jpg"),
          require("../assets/bg_9.jpg"),
          require("../assets/bg_10.jpg"),
          require("../assets/bg_11.jpg"),
          require("../assets/bg_12.jpg"),
          require("../assets/right.gif"),
          require("../assets/b1.png"),
          require("../assets/b2.png"),
          require("../assets/b3.png"),
          require("../assets/bird1.gif"),
          require("../assets/bird2.gif"),
          require("../assets/bird3.png"),
          require("../assets/bird4.png"),
          require("../assets/car1.png"),
          require("../assets/chart1.png"),
          require("../assets/chart2.png"),
          require("../assets/chart3.png"),
          require("../assets/chart4.png"),
          require("../assets/chart5.png"),
          require("../assets/jiang1.png"),
          require("../assets/jiang2.png"),
          require("../assets/jiang3.png"),
          require("../assets/jiang4.png"),
          require("../assets/p1.png"),
          require("../assets/p2.png"),
          require("../assets/ping_bg.jpg"),
          require("../assets/plane.png"),
          require("../assets/poster1.jpg"),
          require("../assets/poster2.jpg"),
          require("../assets/poster3.jpg"),
          require("../assets/poster4.jpg"),
          require("../assets/poster5.jpg"),
        ];
        for (let i = 0; i < imgArry.length; i++) {
          var image = new Image();
          image.src = imgArry[i];
          image.onload = function () {
            ++imgNum;
            that.loadNum = imgNum;
            if (imgNum >= imgArry.length) {
              that.loadNum = 100;
              setTimeout(() => {
                that.loadingShow = false;
                that.getInitData(0);
              }, 30);
            }
          };
          image.error = function (e) {
            that.$toast.fail("请检查一下网络哦");
          };
        }
      } else {
        that.getInitData(top);
        that.loadingShow = false;
        that.showBtn = false;
        that.showTip = true;
        that.showCover = false;
      }
    },

    getLight() {
      this.gifShow = true;
      this.showBtn = false;
      let that = this;
      let timer = setTimeout(() => {
        that.gifShow = false;
        that.init();
      }, 5000);
    },
    init() {
      let that = this;
      let covreBox = document.getElementById("coverBox");
      covreBox.classList.add("cover-ani");
      let timer = setTimeout(() => {
        that.showCover = false;
        that.showTip = true;
      }, 2000);
      let timer1 = setTimeout(() => {
        clearTimeout(timer);
        that.showTip = false;
      }, 8000);
    },
    getInitData(top) {
      let that = this;
      this.$nextTick(() => {
        this.fontSize = this.getFont();
        this.contanier = document.getElementById("contanier");
        this.contanier.style.overflow = "hidden";
        document.getElementById("contanier").scrollTop = Number(top);

        if (top != 0) {
          let id = "ping" + ++that.$route.query.index;
          that.loadingShow = false;
          that.showTip = false;
          that.$nextTick(() => {
            that.addAnimate(id, "zoomIn");
          });
        }
        that.timer = setTimeout(function () {
          this.contanier.style.overflow = "auto";
          let cover = document.getElementById("cover");
          cover.style.display = "none";
        }, 800);
      });
    },
    handleScroll() {
      let scrollTop = this.contanier.scrollTop;
      this.scrollTop = scrollTop;
      let remTop = scrollTop / this.fontSize; // 获取页面卷去的rem
      if (remTop > 5 && remTop <= 10) {
        this.addAnimate("text1", "zoomIn");
      } else if (remTop > 100 && remTop <= 115) {
        this.addAnimate("ping1", "zoomIn");
      } else if (remTop > 130 && remTop <= 145) {
        this.addAnimate("ping2", "zoomIn");
      } else if (remTop > 340 && remTop <= 355) {
        this.addAnimate("ping3", "zoomIn");
      } else if (remTop > 460 && remTop <= 475) {
        this.addAnimate("p1", "fadeIn");
      } else if (remTop > 590 && remTop <= 605) {
        this.addAnimate("p2", "zoomIn");
        this.addAnimate("ping4", "zoomIn");
      } else if (remTop > 1170 && remTop <= 1185) {
        this.addAnimate("b3", "fadeIn");
      } else if (remTop > 1365 && remTop <= 1380) {
        this.addAnimate("ping5", "zoomIn");
      }
    },
    // 字体做动效
    addAnimate(id, effect) {
      let node = document.getElementById(id);
      node.classList.remove("hidden");
      node.classList.add(effect);
    },
    // 消失动效
    removeAnimate() {
      for (let i = 3; i <= 26; i++) {
        let node = document.getElementById("text" + i);
        node.classList.add("hidden");
      }
    },
    getFont() {
      var ration = 2;
      var params = {
        defaultFontSize: 20,
        designWidth: 750,
      };
      var clientWidth = document.documentElement.clientWidth,
        ration = clientWidth / params.designWidth;
      return ration * params.defaultFontSize;
    },
    toPing(index) {
      this.$router.replace({
        name: "ping",
        query: { index: index, top: this.scrollTop },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.index-box {
  width: 100vw;
  overflow-x: hidden;
  .cover {
    z-index: 101;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #d9bb95;
    color: #675041;
    .tip {
      width: 9.75rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -5rem;
      animation: mymove 1.5s ease-in-out infinite;
    }
    .tip-text {
      transform: rotate(90deg);
      font-size: 1.5rem;
      margin-right: 5rem;
    }
  }
  .black-box {
    width: 50.05vw;
    height: 100vh;
    position: fixed;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .cover-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.75);
  }
  .cover-ani {
    animation: myCover 2s ease-in-out infinite;
  }
  // .left-box {
  //   left: 0;
  // }
  // .right-box {
  //   right: 0;
  // }
  .right-gif {
    position: absolute;
    top: 0;
    left: -4rem;
    width: 50rem;
    height: 100vh;
    object-fit: cover;
  }
  .gif-ai {
    animation: myGif 6s ease-in-out 1;
  }
  .deng-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    .right {
      position: absolute;
    }
    .right1 {
      width: 8rem;
      top: 2vh;
      left: -98vw;
      animation: mydeng1 4s ease-in 1;
    }

    .right3 {
      width: 10rem;
      top: 30vh;
      left: -97vw;
      animation: mydeng3 4s ease-in 1;
    }

    .right6 {
      width: 5rem;
      top: 50vh;
      left: -96vw;
      animation: mydeng3 4s ease-in 1;
    }
    .right7 {
      width: 8.7rem;
      top: 60vh;
      left: -65vw;
      animation: mydeng2 3.8s ease-in 1;
    }
    .right9 {
      width: 5.7rem;
      top: 80vh;
      left: -60vw;
      animation: mydeng2 4.5s ease-in 1;
    }
    .right10 {
      width: 4.8rem;
      top: 90vh;
      left: -90vw;
      animation: mydeng1 4.2s ease-in 1;
    }
    .right12 {
      width: 6.8rem;
      top: 40vh;
      left: -50vw;
      animation: mydeng2 4.2s ease-in 1;
    }
    .right13 {
      width: 9.8rem;
      top: 2vh;
      left: -50vw;
      animation: mydeng1 4.2s ease-in 1;
    }
    .right15 {
      width: 8.9rem;
      top: 80vh;
      left: -60vw;
      animation: mydeng3 3.6s ease-in 1;
    }
    .right16 {
      width: 8.9rem;
      top: 50vh;
      left: -30vw;
      animation: mydeng2 4.6s ease-in 1;
    }

    .right18 {
      width: 12rem;
      top: 44vw;
      left: -45vw;
      animation: mydeng2 4.8s ease-in 1;
    }
  }
  .tip-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    .head {
      width: 8.6rem;
      position: fixed;
      top: 80vh;
      left: 19rem;
      animation: myTip 2s ease-in-out infinite;
    }
  }
  .light-btn {
    width: 29.75rem;
    position: fixed;
    left: 3.875rem;
    top: calc(50vh - 27.65rem);
    animation: myBtn 2s ease-in-out infinite;
  }
  .left-ani {
    animation: myLeft 3s ease-in-out 1;
  }
  .right-ani {
    animation: myRight 3s ease-in-out 1;
  }
  .index-bg {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    .text {
      position: absolute;
    }
    .text1 {
      width: 23.2rem;
      top: 28.5rem;
      left: 6.9rem;
    }
    .text2 {
      width: 24.1rem;
      top: 124.6rem;
      left: 6rem;
    }
    .text3 {
      width: 23.8rem;
      top: 360.5rem;
      left: 3.1rem;
    }
    .text4 {
      width: 24.1rem;
      top: 564.4rem;
      left: 6rem;
    }
    .text5 {
      width: 23.25rem;
      top: 812.8rem;
      left: 10rem;
    }
    .text6 {
      width: 21.95rem;
      top: 1096.6rem;
      left: 10rem;
    }
    .text7 {
      width: 23.25rem;
      top: 1270.3rem;
      left: 11rem;
    }
    .text8 {
      width: 23.25rem;
      top: 1360.65rem;
      left: 10rem;
    }
    .text9 {
      width: 21.95rem;
      top: 1428.6rem;
      left: 11rem;
    }
    .text10 {
      width: 23.25rem;
      top: 1520.05rem;
      left: 9.25rem;
    }
    .bird3-box {
      width: 37.5rem;
      height: 170rem;
      overflow: hidden;
      position: absolute;
      top: 158rem;
      left: 0;
      .bird3 {
        width: 14.9rem;
        top: 0rem;
        left: -19rem;
        animation: mybird3 9s ease-in-out infinite;
      }
    }
    .bird4-box {
      width: 37.5rem;
      height: 190rem;
      overflow: hidden;
      position: absolute;
      top: 161rem;
      left: 0;
      .bird4 {
        width: 8.35rem;
        top: 0rem;
        right: -10rem;
        animation: mybird4 11.3s ease-in-out 2s infinite;
      }
    }

    .b1 {
      width: 7.2rem;
      top: 365rem;
      left: 11.5rem;
      animation: myb1 9s ease-in-out 1s infinite;
    }
    .b2 {
      width: 14.4rem;
      top: 360rem;
      left: 4.5rem;
      animation: myb2 5s ease-in-out 2s infinite;
    }
    .p1 {
      width: 21.3rem;
      top: 499rem;
      left: 2.5rem;
    }
    .p2 {
      width: 13.4rem;
      top: 625rem;
      left: 3.5rem;
    }
    .bird1 {
      width: 22.1rem;
      top: 656rem;
      left: 0.5rem;
    }
    .bird2 {
      width: 10.85rem;
      top: 829rem;
      left: 0.5rem;
    }
    .bird5-box {
      width: 37.5rem;
      height: 100rem;
      overflow: hidden;
      position: absolute;
      top: 400rem;
      left: 0;
      .bird5 {
        width: 15rem;
        position: absolute;
        left: -15rem;
        bottom: 0;
        animation: mybird11 8.8s ease-in-out infinite;
      }
    }
    .bird12-box {
      width: 37.5rem;
      height: 80rem;
      overflow: hidden;
      position: absolute;
      top: 420rem;
      left: 0;
      .bird12 {
        width: 28rem;
        position: absolute;
        left: -28rem;
        top: 0;
        animation: mybird12 10.5s ease-in-out infinite;
      }
    }
    .bird6-box {
      width: 37.5rem;
      height: 100rem;
      overflow: hidden;
      position: absolute;
      top: 680rem;
      left: 0;
      .bird6 {
        width: 10rem;
        position: absolute;
        left: 100vw;
        top: 0;
        animation: mybird6 8s ease-in-out infinite;
      }
    }
    .bird8-box {
      width: 37.5rem;
      height: 180rem;
      overflow: hidden;
      position: absolute;
      top: 680rem;
      left: 0;
      .bird8 {
        width: 10rem;
        position: absolute;
        left: -17rem;
        top: 30rem;
        animation: mybird8 11.3s ease-in-out infinite;
      }
    }
    .bird9-box {
      width: 37.5rem;
      height: 180rem;
      overflow: hidden;
      position: absolute;
      top: 600rem;
      left: 0;
      .bird9 {
        width: 10rem;
        position: absolute;
        left: -17rem;
        bottom: 0;
        animation: mybird9 11.3s ease-in-out infinite;
      }
    }
    .bird10-box {
      width: 37.5rem;
      height: 220rem;
      overflow: hidden;
      position: absolute;
      top: 690rem;
      left: 0;
      .bird10 {
        width: 10rem;
        position: absolute;
        left: -10rem;
        bottom: 0;
        animation: mybird10 18.3s ease-in-out infinite;
      }
    }
    .ping {
      width: 4.3rem;
      position: absolute;
      left: 3rem;
    }
    .ping1 {
      top: 142rem;
    }
    .ping2 {
      top: 172rem;
    }
    .ping3 {
      top: 388rem;
    }
    .ping4 {
      top: 625rem;
    }
    .ping5 {
      top: 1397rem;
    }
    .car-box {
      width: 37.5rem;
      height: 246rem;
      position: absolute;
      top: 992rem;
      left: 0rem;
      overflow: hidden;
      .car1 {
        width: 29rem;
        left: 0rem;
        top: 41.5rem;
        // left: ;
        // animation: myCar 4s ease-in-out infinite;
      }
    }
    .b3-box {
      width: 37.5rem;
      height: 76.8rem;
      position: absolute;
      top: 1197rem;
      left: 0;
      overflow: hidden;

      .b3 {
        width: 34.55rem;
        top: 0rem;
        left: 5.5rem;
      }
    }

    .jingmen {
      width: 22.9rem;
      top: 1262rem;
      left: 10.5rem;
    }
    .plane {
      width: 16.9rem;
      height: 57.3rem;
      background: url("../assets/plane.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 1291rem;
      left: 9.5rem;
      animation: myplane 8s ease-in-out 2s infinite;
      .jiang1 {
        width: 5.8rem;
        position: absolute;
        left: 6rem;
        top: 18rem;
        animation: myfirst 0.5s infinite linear;
      }
      .jiang2 {
        width: 6.6rem;
        position: absolute;
        left: 5rem;
        top: 25rem;
        animation: myfirst 0.5s infinite linear;
      }
      .jiang3 {
        width: 5.8rem;
        position: absolute;
        left: 5rem;
        top: 43rem;
        animation: myfirst 0.5s infinite linear;
      }
      .jiang4 {
        width: 5rem;
        position: absolute;
        left: 5.4rem;
        top: 52rem;
        animation: myfirst 0.5s infinite linear;
      }
    }
    .item {
      width: 37.5rem;
    }
    .item1 {
      height: 94.45rem;
      background: url("../assets/bg_1.jpg") no-repeat;
      background-size: cover;
    }
    .item2 {
      height: 126.2rem;
      background: url("../assets/bg_2.jpg") no-repeat;
      background-size: cover;
    }
    .item3 {
      height: 132.85rem;
      background: url("../assets/bg_3.jpg") no-repeat;
      background-size: cover;
    }
    .item4 {
      height: 135.95rem;
      background: url("../assets/bg_4.jpg") no-repeat;
      background-size: cover;
    }
    .item5 {
      height: 147.95rem;
      background: url("../assets/bg_5.jpg") no-repeat;
      background-size: cover;
    }
    .item6 {
      height: 154.45rem;
      background: url("../assets/bg_6.jpg") no-repeat;
      background-size: cover;
    }
    .item7 {
      height: 148.2rem;
      background: url("../assets/bg_7.jpg") no-repeat;
      background-size: cover;
    }
    .item8 {
      height: 123.25rem;
      background: url("../assets/bg_8.jpg") no-repeat;
      background-size: cover;
    }
    .item9 {
      height: 136.65rem;
      background: url("../assets/bg_9.jpg") no-repeat;
      background-size: cover;
    }
    .item10 {
      height: 133.05rem;
      background: url("../assets/bg_10.jpg") no-repeat;
      background-size: cover;
    }
    .item11 {
      height: 156.35rem;
      background: url("../assets/bg_11.jpg") no-repeat;
      background-size: cover;
    }
    .item12 {
      height: 144.1rem;
      background: url("../assets/bg_12.jpg") no-repeat;
      background-size: cover;
    }
  }
}

@keyframes mymove {
  0% {
    transform: rotate(80deg);
  }
  100% {
    transform: rotate(-110deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue